import { Components, Theme } from "@mui/material/styles";

const Paper: Components<Theme> = {
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none",
      },
    },
  },
};

export default Paper;
